import { type RegisteredStatsigEvent } from "@repo/statsig";
import { isRedirectError } from "src/lib/utils/is-redirect-error";

/**
 * Report a failed visit-request confirmation, shared by both home wizards.
 *
 * A Next `redirect()` surfaces as a thrown error but is normal control flow, so
 * it is ignored (not logged). Returns `true` when the error is a real failure
 * (already logged here) — callers use that to decide whether to reset the
 * patient-picker UI (`dispatch({ type: "SELECT_PATIENT_CANCEL" })`); `false`
 * for a redirect, where the navigation is proceeding and nothing should reset.
 */
export function reportConfirmVisitError(
  err: unknown,
  logEvent: (event: RegisteredStatsigEvent) => void
): boolean {
  if (isRedirectError(err)) return false;
  logEvent({
    eventName: "confirm_visit_request_error",
    value: err instanceof Error ? err.message : "unknown",
  } as RegisteredStatsigEvent);
  return true;
}
